<div *ngIf="message" style="box-sizing: border-box;padding:16px;border-top: 1px solid #2d5e08">
  <div class="m-3" [ngClass]="message.cssClass" style="margin:0!important;">
    {{ message.text }}
  </div>
</div>
